import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import uuid from 'uuid';
import { getCellAttrs, getCellDomAttrs } from '@atlaskit/adf-schema';
import { DOMSerializer } from '@atlaskit/editor-prosemirror/model';
var DEFAULT_COL_SPAN = 1;
var DEFAULT_ROW_SPAN = 1;
var TableCellNodeView = /*#__PURE__*/function () {
  function TableCellNodeView(node, view, getPos, observer) {
    _classCallCheck(this, TableCellNodeView);
    this.view = view;
    this.node = node;
    var _DOMSerializer$render = DOMSerializer.renderSpec(document, node.type.spec.toDOM(node)),
      dom = _DOMSerializer$render.dom,
      contentDOM = _DOMSerializer$render.contentDOM;
    this.getPos = getPos;
    this.dom = dom;
    this.contentDOM = contentDOM;
    if (observer) {
      this.contentDOM.id = uuid();
      this.observer = observer;
      observer.observe(this.contentDOM);
    }
  }
  _createClass(TableCellNodeView, [{
    key: "updateNodeView",
    value: function updateNodeView(node) {
      var _this = this;
      if (this.node.type !== node.type) {
        return false;
      }
      var attrs = getCellDomAttrs(this.node);
      var nextAttrs = getCellDomAttrs(node);
      var _getCellAttrs = getCellAttrs(this.dom),
        colspan = _getCellAttrs.colspan,
        rowspan = _getCellAttrs.rowspan;

      // need to rerender when colspan/rowspan in dom are different from the node attrs
      // this can happen when undoing merge cells
      if (colspan !== (node.attrs.colspan || DEFAULT_COL_SPAN) || rowspan !== (node.attrs.rowspan || DEFAULT_ROW_SPAN)) {
        return false;
      }

      // added + changed attributes
      var addedAttrs = Object.entries(nextAttrs).filter(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        return attrs[key] !== value;
      });
      var removedAttrs = Object.keys(attrs).filter(function (key) {
        return !nextAttrs.hasOwnProperty(key);
      });
      if (addedAttrs.length || removedAttrs.length) {
        addedAttrs.forEach(function (_ref3) {
          var _ref4 = _slicedToArray(_ref3, 2),
            key = _ref4[0],
            value = _ref4[1];
          return _this.dom.setAttribute(key, value || '');
        });
        removedAttrs.forEach(function (key) {
          return _this.dom.removeAttribute(key);
        });
        return true;
      }

      // Return true to not re-render this node view
      if (this.node.sameMarkup(node)) {
        return true;
      }
      return false;
    }
  }, {
    key: "update",
    value: function update(node) {
      var didUpdate = this.updateNodeView(node);
      if (didUpdate) {
        this.node = node;
      }
      return didUpdate;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.observer) {
        this.observer.unobserve(this.contentDOM);
      }
    }
  }]);
  return TableCellNodeView;
}();
export { TableCellNodeView as default };